<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import {
    users_tokenToUser
  } from "@/common/api.js"

  export default {
    name: 'app',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        showPath:true,
       pathArr : ['/noPage',"/login","/"]
      }
    },
    components:{
      // Nav,Header,Project
    },
    methods:{
      GetQueryString(name) {
        console.log("name",name)
              var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
              console.log("reg",reg)
              var r = window.location.search.substr(1).match(reg);
              console.log(r)
              if (r != null) return unescape(r[2]);
              return null;
            },
      getUserInfoByToken(token){
        console.log('token',token)
        users_tokenToUser({
          token:token
        }).then((res) => {
          console.log(res)
          if(res.success){
            sessionStorage.setItem('userId', res.data.userId)
            this.$store.commit('setUserId',res.data.userId)
            sessionStorage.setItem('userRole', res.data.role)
            this.$store.commit('setUserRole',res.data.role)
            sessionStorage.setItem('userAccount',res.data.account)
            this.$store.commit('setUserAccount',res.data.account)
            sessionStorage.setItem('userPermission', res.data.permission)
            this.$store.commit('setUserPermission',res.data.permission)

            sessionStorage.setItem('role', res.data.role)

            sessionStorage.setItem('usercname', res.data.account)
             this.$router.replace("/home/totalAnalyze")
          }else{
            this.$message.error("获取用户信息失败，请重新登录")
            sessionStorage.clear()
            this.$router.replace('/login')
          }
        }).catch((err) => {
          console.log(err)
          this.$message.error("获取用户信息失败，请重新登录")
          sessionStorage.clear()
          this.$router.replace('/login')
        })
      },

      getQueryVariable ()  {
        var url = window.location.href ;
         console.log(url)
         if(url.indexOf('token')!= -1){
           var dz_url = url.split('#')[0];                //获取#/之前的字符串
             var cs = dz_url.split('?')[1];                //获取?之后的参数字符串
             var cs_arr = cs.split('&');                    //参数字符串分割为数组
             var cs={};
             for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
               cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
             }
           return cs
         }else{
           return {}
         }
                //获取当前url


      },

      routerChange(){
      	// this.path = this.$route.path
       //  console.log(this.path)
      	// let pathArr = ['/noPage',"/login","/"]
       //  console.log(this.$route.path)
      	// if(pathArr.indexOf(this.$route.path) ==-1){
      	// 	this.showPath = true
      	// }else{
      	// 	this.showPath = false
      	// }
      }
    },
    created() {
      console.log(window.location.href)
      let tokenObj =  this.getQueryVariable()

      console.log(tokenObj)
      if(!tokenObj.hasOwnProperty('token') && sessionStorage.getItem('token') == null ){
        this.$router.replace('/login')
      }else if(tokenObj.hasOwnProperty('token') && sessionStorage.getItem('token') == null){
        sessionStorage.setItem('token',tokenObj.token)
        this.getUserInfoByToken(tokenObj.token)
      }
    },
    watch:{
      "$route": "routerChange"
    }
  }
</script>

<style>
  .v-enter{
   opacity: 0;
   transform:translateX(5%);

  }
  .v-enter-active{
   transition: 0.5s;

  }
  .v-enter-to{
   opacity: 1;
   transform:translateX(0);
  }
  .v-leave{
   opacity: 1;
   transform:translateX(0);
  }
  .v-leave-to{
   opacity:0;
   transform:translateX(-5%);
  }
  .v-leave-active{
   transition: 0.5s;
  }
  #app{
    /* display: flex; */
    /* flex-direction: column; */
    height: 100%;
    width: 100%;
    background-color:#F0F0F0;
  }
  .main{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;


  }
  .mian-left{
    /* width: 15%; */
    /* background-color: #F8F8FF; */
  }
  .mian-right{
    width:calc(100% - 288px);
    margin-top: 70px;
    /* height: 50px; */
    background-color: #F8F8FF;
    position: absolute;
    right: 0;
  }
  .main-content{
    /* height: 100%; */
    width: 100%;
    /* background-color: #FFFF00; */
    /* margin-top: 50px; */
    /* min-height: 800px; */
    background-color: #F0F0F0;
    /* position: fixed; */
  }
  .el-message{
    z-index:10000!important
  }
</style>



// WEBPACK FOOTER //
// src/App.vue